window.initGlobalAOS = function () {
  if (!window.AOS) return;

  AOS.init({
    once: true,
    easing: 'ease-out-cubic',
  });
};
document.addEventListener('DOMContentLoaded', () => {
  initGlobalAOS();
});